import React from 'react'
import moment from 'moment'
import '../assets/scorecards.scss'

function Scorecards(props) {
    const { item, onClicked } = props

    return (
        <div className="card cursor" onClick={() => onClicked(item)}>
            <div className="card-body">
                <div className="row">
                    <div className="col-10-mobile col-sm-10 detail">
                        <div className="row no-gutters">
                            <div className="col-3 col-md-2 col-lg-1">
                                <div className={`play-date-box ${item['adjust_total'] === 0 ? 'bg-yellow' : 'bg-blue'}`}>
                                    <h6 className="color-white mb-0">{moment(item['play_date']).format('DD')} </h6>
                                    <small className="color-white d-block">{moment(item['play_date']).format('MM/YYYY')}</small>
                                </div>
                            </div>
                            <div className="col-8 col-md-10 col-lg-11 text-left">
                                {item['course_name']}
                            </div>
                        </div>
                        <div className="row no-gutters mt-3 text-left tee-off-detail">
                            <div className="col-6 col-md-3 col-xl-2">
                                <h6 className={`mb-0 ${item['adjust_total'] === 0 ? 'yellow' : 'blue'}`}>{item['course_rating'] !== 0 ? item['course_rating'] : 'N/A'} / {item['slope_rating'] !== 0 ? item['slope_rating'] : 'N/A'}</h6>
                                <small className="d-block">Course / Slope rating</small>
                            </div>
                            <div className="col-6 col-md-3 col-xl-2">
                                <h6 className={`mb-0 ${item['adjust_total'] === 0 ? 'yellow' : 'blue'}`}>{item['handicap_diff'] ? item['handicap_diff'] : 'N/A'}</h6>
                                <small className="d-block">Handicap differential</small>
                            </div>
                        </div>
                    </div>
                    <div className={`col-2-mobile col-sm-2 gross-box ${item['adjust_total'] === 0 ? 'bg-yellow' : 'bg-blue'}`}>
                        <h5 className="color-white">Gross</h5>
                        <h3 className="color-white">{item['gross']}</h3>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Scorecards
